import { AxiosInstance } from 'axios';
import {
	EventTicketsReservationDto,
	EventTicketsTotalsWithReservationsDto,
	UpsertEventTicketsReservationDto,
} from '@sweatpals/shared';

export class EventTicketsReservationService {
	constructor(private readonly httpClient: AxiosInstance) {}

	public async getEventTicketsCountAndSpotsWithReservations(
		eventBaseId: string,
		instance: string
	): Promise<EventTicketsTotalsWithReservationsDto> {
		const { data } = await this.httpClient.get(`/event-tickets-reservations/${eventBaseId}/instance/${instance}/ticket-spots-count`);

		return data;
	}

	public async getUserEventTicketReservations(eventBaseId: string, instance: string): Promise<EventTicketsReservationDto[]> {
		const { data } = await this.httpClient.get(`/event-tickets-reservations/${eventBaseId}/instance/${instance}/my-reservations`);

		return data;
	}

	public async upsertUserEventTicketReservations (
		eventBaseId: string,
		instance: string | Date,
		body: UpsertEventTicketsReservationDto[]
	): Promise<void> {
		await this.httpClient.post(
			`/event-tickets-reservations/${eventBaseId}/instance/${
				instance instanceof Date ? instance.toISOString() : instance
			}/upsert-my-reservations`,
			body
		);
	}
}
